import React, { useEffect, useState } from 'react';
import './BridalMakeup.css';
import { FaPhone, FaRegStar, FaListAlt, FaHeart, FaExclamationTriangle } from 'react-icons/fa';
import { MdExpandMore, MdExpandLess } from 'react-icons/md';
import { Link } from 'react-router-dom';
import { getBridalImages } from '../../services/galleryService';

const BridalMakeup = () => {
  const [images, setImages] = useState([]);
  const [current, setCurrent] = useState(0);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerOpen1, setDrawerOpen1] = useState(false);

  useEffect(() => {
    getBridalImages().then(setImages);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [images]);

  const toggleDrawer = () => setDrawerOpen(!drawerOpen);
  const toggleDrawer1 = () => setDrawerOpen1(!drawerOpen1);

  return (
    <div className="bridal-page">
      <div className=" slide-up">
  <h1 className="page-title">Bridal Makeup</h1>
</div>

      <div className="gallery-section">
        {images.length > 0 && <img src={images[current]} alt="main" className="main-image" />}
        <div className="thumbnail-strip">
          {images.map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`thumb-${index}`}
              className={`thumbnail ${current === index ? 'active' : ''}`}
              onClick={() => setCurrent(index)}
            />
          ))}
        </div>
      </div>

      <div className="buttons-container">
        <button
    className="drawer-toggle-btn"
    onClick={toggleDrawer}
  >
    All You Need to Know About Bridal Makeup ▾
  </button>
{drawerOpen && (
        <div className="drawer-content">
  <p>
    Bridal makeup is one of our most loved (and booked!) services — and honestly, we’re so honoured every time a bride chooses us to be part of her big day. It gives us that warm feeling knowing you trust us with your once-in-a-lifetime look!!
  </p>
  <p>
    But let’s be real — our bridal package isn’t just about makeup. It’s a full on glow-up experience.
  </p>
  <p><strong>Here’s what’s really in the magic mix:</strong></p>
  <ul>
    <li>🤩<strong>Detailed Skin Prep</strong> - Brides get the VIP glow-up! We kick things off with a lymphatic drainage massage to de-puff and boost circulation, then pamper your skin with a custom routine — all to make sure you’re glowing inside and out before the glam magic!</li>
    <li>✨ <strong>High-Definition Makeup</strong> — So you look flawless in person and in photos — every light, every angle, every single shot. No filter needed. We use only premium, international high-end products to give you that effortlessly luxe finish.</li>
    <li>💁🏻‍♀️ <strong>Hairstyling with a Little Extra Sparkle</strong> — Think sleek buns, soft curls, or dreamy braids, topped with real flowers or beautiful hair accessories (yes, we help you pick).</li>
    <li>👁️ <strong>Real Hair Lashes & Premium Colored Lenses</strong> — For that dreamy, twinkling “I just walked out of a fairytale” effect.</li>
    <li>👗 <strong>Custom Draping</strong> — Draping to flatter your body type and stay secure through every dance move.</li>
  </ul>
  <p>
    📝 Just a heads-up: Hair extensions, hair accessories, real flowers, and travel to the venue are not included — but can totally be arranged separately!
  </p>
  <p><strong>And here’s where we go the extra mile (because that’s how we roll):</strong></p>
  <ul>
    <li>📞 <strong>Complimentary Consultation Call</strong> — Before a single brush touches your face, we’re diving deep into all things beauty and bridal. We spill all the glam tea — from understanding your skin type and sharing skincare tips, to figuring out the most flattering makeup finishes, eyeshadow tones, and even lens colors that bring out your sparkle.</li>
    <li>We chat about hairstyles, hair adornments, and draping styles that elevate your entire look. And yes — we even throw in styling tips to make sure your whole vibe is picture-perfect from head to toe.</li>
    <li>Think of it as your own little glam planning party — where every detail is carefully considered, and nothing is left to chance. Because when it comes to your big day, you're not just getting makeup... you're getting a whole moment.</li>
    <li>🧴 <strong>Skincare Suggestions (Not Prescriptions!)</strong> — We recommend a few tried-and-tested products that help prep your skin beautifully for makeup.</li>
    <li>🚨 Mini disclaimer: We’re not dermatologists! Always patch test and listen to your skin.</li>
    <li>But it doesn’t end there — we stay in touch with you like your glam BFF. 💌</li>
    <li>We check in, send little reminders to drink water (yes, hydration is the real MVP), eat nourishing food, and stick to your skincare routine, so you’re glowing before the makeup even begins.</li>
    <li>We’re not just here to make you look stunning — we’re here to make you feel amazing, supported, and stress-free from the first message to the final touch-up.</li>
  </ul>
  <p><strong>Ready to feel like the most radiant version of yourself?</strong></p>
  <p>
    We’ve got you. And we can’t wait to be part of your big day. 💫 For more details, <a href="/make-an-enquiry">make an inquiry</a>.
  </p>

  
</div>
      )}

      <button
    className="drawer-toggle-btn"
    onClick={toggleDrawer1}
  >
    Bridal Trial ▾
  </button>
  {drawerOpen1 && (
        <div className="drawer-content">
  <h3>BRIDAL TRIALS</h3>
  <p><strong>Bridal Trials – Try Before You Tie the Knot.</strong> Let’s be real, your wedding day is not the time for makeup surprises. That’s why we offer bridal trials exclusively for our lovely soon-to-be brides. Think of it as a fun little dress rehearsal… but for your face!</p>

  <h4>💕 What to Expect:</h4>
  <ul>
    <li>We start with a friendly consultation to understand your makeup preferences for the big day. No idea what you want? Don’t stress — we’ll help guide you based on your skin, style, and overall wedding vibe.</li>
    <li>During your bridal makeup trial, we will:
      <ul>
        <li>✨ Create a <strong>complete face of makeup</strong>.</li>
        <li>👁️ Demonstrate <strong>two distinct eye makeup looks</strong> — one for your bridal ceremony and another for your sangeet/cocktail — so you can compare different colour families, overall styles, and finishes.</li>
        <li>🌸 Show you <strong>two blush placement techniques</strong> using different blush shades to help you choose the most flattering look for your features and bridal aesthetic.</li>
      </ul>
    </li>
    <li>The whole process takes around 2 hours, and we recommend you keep the makeup on for at least half an hour after the makeup is done so you can see how it settles and wears.</li>
  </ul>

  <p><strong>Please note:</strong></p>
  <ul>
    <li><strong>False lashes and contact lenses are not applied during makeup trials.</strong></li>
    <li><strong>Hair trials are not included</strong> as part of the makeup trial session.</li>
  </ul>

  <h4>✨ A Few Important Things to Know:</h4>
  <ul>
    <li>Please wear neutral colour or a color close to your wedding outfit — it really helps you visualise the final look better!</li>
    <li>Makeup will need to be removed before you leave — we’ll provide everything you need for that.</li>
    <li>All trials take place at our home — we’ll share the address when you book your slot.</li>
    <li>The trial fee is a separate paid service and is non-adjustable, even if you choose to book us for your wedding day.</li>
    <li>To keep things cozy and distraction-free, we kindly request you to bring not more than two guests with you.</li>
  </ul>

  <h4>Terms &amp; Conditions</h4>
  <ul>
    <li>Please note that scheduling a trial does not guarantee a hold on your wedding/event dates.</li>
    <li>In the event that we receive a confirmed booking for your event dates prior to your trial, your trial booking amount will be fully refunded.</li>
    <li>We kindly request that you confirm your decision to proceed with a booking within 2 days after your trial, so we can plan and reserve your dates accordingly.</li>
  </ul>

  <p>
    We’re here to make this part of your bridal journey feel special, stress-free, and honestly... fun! For more details, <a href="/make-an-enquiry">make an enquiry</a>.
  </p>
</div>
      )}

  <button
    className="primary-btn"
    onClick={() => window.location.href = "/make-an-enquiry"}
  >
    Make an Enquiry
  </button>

  <button
    className="primary-btn"
    onClick={() => window.location.href = "/NoteToBride"}
  >
    Note To Bride
  </button>

  
</div>


      
    </div>
  );
};

export default BridalMakeup;